module.exports = __webpack_public_path__ + "static/media/hitomi-win.b25a0858.png";